"use client";

import Link from "next/link";
import { Hero, ActionLarge } from "@bumble/ui-kit";
import MaxWidth from "@/components/MaxWidth";
import Content from "./content";
import { PAGE_TITLE } from "./constants";
import styles from "./AiInterviewProcess.module.css";

/**
 * Client half of the page. The ui-kit is client-only (it pulls in React hooks
 * at module scope), so anything importing it must sit behind a "use client"
 * boundary — the same reason src/components/bumble/* are all client
 * components. page.tsx stays a server component so it can await params.
 */

type Props = {
  /** Route locale, used to point the back link at the localised home page. */
  locale: string;
};
export default function AiInterviewProcess({
  locale
}: Props) {
  return <>
      {/*
       * The image-related props are required by the ui-kit's exported Hero
       * type even though this variant does not use them, so they are passed
       * explicitly as undefined — same as src/components/bumble/Hero.
       */}
      <Hero variant="cta" backgroundColor="yellow" ctaBox={{
      title: PAGE_TITLE
    }} backgroundImageSrc={undefined} words={undefined} descriptionText={undefined} animation={undefined} overlay={undefined} />
      <MaxWidth>
        <div className={styles.body}>
          <div className={styles.rail}>
            <div className={styles.railInner}>
              <ActionLarge>
                <Link href={`/${locale}`} className={styles.backLink}>
                  Back to Careers page
                </Link>
              </ActionLarge>
            </div>
          </div>
          <Content />
        </div>
      </MaxWidth>
    </>;
}